import { readableColor, tint } from 'polished';
import { REGISTERED_APPS } from '../shared/types/Apps';
import { MoneyFormats } from '../types';

export type PopupSettings = {
  buttonText: string;
  buttonTextAdded: string;
  buttonTextUpgraded: string;
  buttonTextUpgrade: string;
  primaryButton: string;

  //todo remove
  iframePrimaryColor: string;
};

function getColorDerivate(color: string, level: 2 | 3 | 5 | 'readableColor') {
  if (level === 'readableColor') {
    return readableColor(color);
  }

  switch (level) {
    case 2: {
      return tint(0.375, color);
    }
    case 3: {
      return tint(0.75, color);
    }
    case 5: {
      return tint(0.965, color);
    }
  }
}

function setMoneyFormats(
  moneyFormats: MoneyFormats,
  defaultFormat: boolean,
  appName: REGISTERED_APPS,
) {
  if (appName === REGISTERED_APPS.ADD_TO_CART) {
    window.CandyRack.currency = {
      moneyFormats,
      defaultFormat,
      format: 'money_format',
    };
  } else if (appName === REGISTERED_APPS.CHECKOUT_BUTTON) {
    // CandyCart (Checkout Button) uses the same shape as CR/LU
    // so currency.ts can read a template consistently
    window.CandyCart = window.CandyCart || ({} as any);
    window.CandyCart.currency = {
      moneyFormats,
      defaultFormat,
      format: 'money_format',
    };
  } else if (appName === REGISTERED_APPS.THANK_YOU_PAGE) {
    window.LastUpsell.currency = {
      moneyFormats,
      defaultFormat,
      format: 'money_format',
    };
  }
}

const isElementVisible = (element: HTMLElement) =>
  element.offsetWidth > 0 || element.offsetHeight > 0;

export { getColorDerivate, setMoneyFormats, isElementVisible };
